import React, {Component} from "react";
import Moment from "moment/moment";
import {withTranslation} from "react-i18next";

import employeeService from "../../../../services/Employee.service";
import {contains, formatNumber} from "../../../../utils/jsUtils";

import {DIALOGS} from "../common";
import {GenericDetailTitle} from "./GenericDetailTitle";
import {GenericDetailColumn} from "./GenericDetailColumn";

import {Col} from "@amzn/stencil-react-components/layout";

class AwardInfo extends Component {

  showsNotAcceptedLabel = (dialog) => {
    return contains([DIALOGS.VestedAwardDetailsDialog, DIALOGS.UnvestedAwardDetailsDialog], dialog);
  }

  render () {
    const {award, dialogName, locale, t} = this.props;

    const awardShares = formatNumber(locale, award.shares_awarded);
    let awardInfo = t('StockAwards.Award.AwardInfo', {
      share_quantity: awardShares,
      award_type: employeeService.isRSU(award) ? 'RSUs' : 'Options',
      share_date: Moment(award.awarded_date).format('ll')
    });

    if (!employeeService.isAwardAccepted(award) && this.showsNotAcceptedLabel(dialogName)) {
      awardInfo += " (" + t(`${dialogName}.NotAccepted`) + ")";
    }

    return (
      <Col dataTestId='award_info' gridGap="S200">
        <GenericDetailTitle title={t(`${dialogName}.AwardInfo`)} />
        <GenericDetailColumn
          label={`${award.amazon_award_id} | ${award.amazon_award_name}`}
          value={awardInfo}
        />
      </Col>
    );
  }
}

export default withTranslation('translationsV2')(AwardInfo);
